import { styled } from "@mui/system";

const ListItemContainer = styled('li')<{ fontSize: string, marginBottom?: string }>(({ fontSize, marginBottom }) => ({
    color: '#F1F7F7',
    fontSize: fontSize,
    fontWeight: '400',
    lineHeight: '18px',
    marginBottom: marginBottom,
    '@media (max-width: 1024px)': {
        fontSize: '12px',
        lineHeight: '16px',
    }
}));

interface ListItemProps {
    fontSize: string;
    marginBottom?: string;
    children: React.ReactNode;
}

export const ListItem = ({ fontSize, children, marginBottom }: ListItemProps) => {
    return <ListItemContainer fontSize={fontSize} marginBottom={marginBottom}>{children}</ListItemContainer>;
};

